import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  equals2au1ep9vhcato as equals,
  hashCodeq5arwsb9dgti as hashCode,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  protoOf180f3jzyo7rfj as protoOf,
  createThis2j2avj17cvnv2 as createThis,
  toString1pkumu07cwy4m as toString,
  getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode,
} from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { FunctionAdapter3lcrrz3moet5b as FunctionAdapter } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/FunctionAdapter.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { Comparator2b3maoeh98xtg as Comparator } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/ComparatorJs.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
} from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { compareValues1n2ayl87ihzfk as compareValues } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/comparisons/Comparisons.mjs';
import { Enum3alwj03lh1n41 as Enum } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/Enum.mjs';
import {
  get_displayColor1gavqb36ugd6h as get_displayColor,
  DirectlyDisplayableStatebtdfi3611j0b as DirectlyDisplayableState,
} from '../../work/payApps/data.mjs';
import {
  get_shortDisplayNamenwyz2dxtvf5g as get_shortDisplayName,
  MonetaryValue__toString_impl_xslc771noy15rjps4pw as MonetaryValue__toString_impl_xslc77,
  Manual3lg0s0ycvhhh4 as Manual,
} from '../../../../../../../../crowpay-shared/com/crowpay/supportModels.mjs';
import { emptySetcxexqki71qfa as emptySet } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Sets.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { AppColors_getInstance3ty7139j9u8g2 as AppColors_getInstance } from '../../../../theming/AppColors.mjs';
import { Companion_instance1i4n4o7mef2za as Companion_instance } from '../../../../../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/Clock.mjs';
import { get_default1l68fybpthpme as get_default } from '../../../../../../../../lightning-server-shared/com/lightningkite/DefaultClock.mjs';
import { _Char___init__impl__6a9atx2js6krycynjoo as _Char___init__impl__6a9atx } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { substringBefore3n7kj60w69hju as substringBefore } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import { toString30pk9tzaqopn as toString_0 } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { Comparable198qfk8pnblz0 as Comparable } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/Comparable.mjs';
import { IllegalArgumentException2asla15b5jaob as IllegalArgumentException } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { ChangeRequestItemWrapperlr7b47p0t9ty as ChangeRequestItemWrapper } from '../../work/changeOrders/data.mjs';
import {
  PendingLineItem7uj25viy3ie8 as PendingLineItem,
  PendingItemChange1hwhwykx2kyit as PendingItemChange,
} from '../../../../../../../../crowpay-shared/com/crowpay/databaseModels.mjs';
import { Companion_getInstance3n9as6ds1py67 as Companion_getInstance } from '../../../../../../../../lightning-server-shared/com/lightningkite/UUID.js.mjs';
import { Collection1k04j3hzsbod0 as Collection } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import {
  Accept733y3zepx42g as Accept,
  RequestComplete2fbpvksxlxjbf as RequestComplete,
} from '../../../../../../../../crowpay-shared/com/crowpay/completionResponse/CompletionResponse.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var Type_LineItem_instance;
var Type_Incident_instance;
var Type_Draw_instance;
var Type_Change_instance;
var Type_entriesInitialized;
function Type_initEntries() {
  if (Type_entriesInitialized)
    return Unit_instance;
  Type_entriesInitialized = true;
  Type_LineItem_instance = Type().ggo('LineItem', 0, 'Line Item');
  Type_Incident_instance = Type().ggo('Incident', 1, 'Incident');
  Type_Draw_instance = Type().ggo('Draw', 2, 'Draw');
  Type_Change_instance = Type().ggo('Change', 3, 'Change');
}
var sam$kotlin_Comparator$0Class;
function sam$kotlin_Comparator$0() {
  if (sam$kotlin_Comparator$0Class === VOID) {
    class $ {
      constructor(function_0) {
        this.hgo_1 = function_0;
      }
      wi(a, b) {
        return this.hgo_1(a, b);
      }
      compare(a, b) {
        return this.wi(a, b);
      }
      i4() {
        return this.hgo_1;
      }
      equals(other) {
        var tmp;
        if (!(other == null) ? isInterface(other, Comparator()) : false) {
          var tmp_0;
          if (!(other == null) ? isInterface(other, FunctionAdapter()) : false) {
            tmp_0 = equals(this.i4(), other.i4());
          } else {
            tmp_0 = false;
          }
          tmp = tmp_0;
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return hashCode(this.i4());
      }
    }
    initMetadataForClass($, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator(), FunctionAdapter()]);
    sam$kotlin_Comparator$0Class = $;
  }
  return sam$kotlin_Comparator$0Class;
}
function ConcernCardInfo$Companion$comparator$lambda(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  var tmp = a.lgo_1.i90();
  var tmp$ret$1 = b.lgo_1.i90();
  return compareValues(tmp, tmp$ret$1);
}
var TypeClass;
function Type() {
  if (TypeClass === VOID) {
    class $ extends Enum() {
      static ggo(name, ordinal, displayName) {
        var $this = this.c4(name, ordinal);
        $this.fgo_1 = displayName;
        return $this;
      }
    }
    initMetadataForClass($, 'Type');
    TypeClass = $;
  }
  return TypeClass;
}
var ManualStateClass;
function ManualState() {
  if (ManualStateClass === VOID) {
    class $ {
      constructor(displayName, color, priority) {
        priority = priority === VOID ? 0 : priority;
        this.vgo_1 = displayName;
        this.wgo_1 = color;
        this.xgo_1 = priority;
      }
      g90() {
        return this.vgo_1;
      }
      fg0() {
        return this.wgo_1;
      }
      i90() {
        return this.xgo_1;
      }
      toString() {
        return 'ManualState(displayName=' + this.vgo_1 + ', color=' + this.wgo_1.toString() + ', priority=' + this.xgo_1 + ')';
      }
      hashCode() {
        var result = getStringHashCode(this.vgo_1);
        result = imul(result, 31) + this.wgo_1.hashCode() | 0;
        result = imul(result, 31) + this.xgo_1 | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof ManualState()))
          return false;
        if (!(this.vgo_1 === other.vgo_1))
          return false;
        if (!this.wgo_1.equals(other.wgo_1))
          return false;
        if (!(this.xgo_1 === other.xgo_1))
          return false;
        return true;
      }
    }
    protoOf($).h90 = get_displayColor;
    protoOf($).f90 = get_shortDisplayName;
    initMetadataForClass($, 'ManualState', VOID, VOID, [DirectlyDisplayableState()]);
    ManualStateClass = $;
  }
  return ManualStateClass;
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance_0 = this;
        var tmp = this;
        // Inline function 'kotlin.comparisons.compareBy' call
        var tmp_0 = ConcernCardInfo$Companion$comparator$lambda;
        // Inline function 'kotlin.comparisons.thenBy' call
        var this_0 = new (sam$kotlin_Comparator$0())(tmp_0);
        var tmp_1 = (a, b) => {
          var previousCompare = this_0.compare(a, b);
          var tmp;
          if (!(previousCompare === 0)) {
            tmp = previousCompare;
          } else {
            // Inline function 'kotlin.comparisons.compareValuesBy' call
            var tmp_0 = a.mgo_1;
            var tmp$ret$2 = b.mgo_1;
            tmp = compareValues(tmp_0, tmp$ret$2);
          }
          return tmp;
        };
        tmp.ygo_1 = new (sam$kotlin_Comparator$0())(tmp_1);
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance_0;
function Companion_getInstance_0() {
  if (Companion_instance_0 === VOID)
    new (Companion())();
  return Companion_instance_0;
}
function Type_LineItem_getInstance() {
  Type_initEntries();
  return Type_LineItem_instance;
}
function Type_Incident_getInstance() {
  Type_initEntries();
  return Type_Incident_instance;
}
function Type_Draw_getInstance() {
  Type_initEntries();
  return Type_Draw_instance;
}
function Type_Change_getInstance() {
  Type_initEntries();
  return Type_Change_instance;
}
var ConcernCardInfoClass;
function ConcernCardInfo() {
  if (ConcernCardInfoClass === VOID) {
    class $ {
      static zgo(type, id, title, state, timestamp, mostRecentMessage, messageName, readBy, actionIcon, timerState, escalationLevel, tags, dialog) {
        Companion_getInstance_0();
        readBy = readBy === VOID ? emptySet() : readBy;
        actionIcon = actionIcon === VOID ? null : actionIcon;
        timerState = timerState === VOID ? null : timerState;
        escalationLevel = escalationLevel === VOID ? null : escalationLevel;
        tags = tags === VOID ? emptySet() : tags;
        dialog = dialog === VOID ? null : dialog;
        var $this = createThis(this);
        $this.igo_1 = type;
        $this.jgo_1 = id;
        $this.kgo_1 = title;
        $this.lgo_1 = state;
        $this.mgo_1 = timestamp;
        $this.ngo_1 = mostRecentMessage;
        $this.ogo_1 = messageName;
        $this.pgo_1 = readBy;
        $this.qgo_1 = actionIcon;
        $this.rgo_1 = timerState;
        $this.sgo_1 = escalationLevel;
        $this.tgo_1 = tags;
        $this.ugo_1 = dialog;
        return $this;
      }
      agp(other) {
        return Companion_getInstance_0().ygo_1.compare(this, other);
      }
      d(other) {
        return this.agp(other instanceof ConcernCardInfo() ? other : THROW_CCE());
      }
      static bgp(type, id, title, state, timestamp, mostRecentMessage, readBy, actionIcon, timerState, escalationLevel, tags, dialog) {
        Companion_getInstance_0();
        readBy = readBy === VOID ? emptySet() : readBy;
        actionIcon = actionIcon === VOID ? null : actionIcon;
        timerState = timerState === VOID ? null : timerState;
        escalationLevel = escalationLevel === VOID ? null : escalationLevel;
        tags = tags === VOID ? emptySet() : tags;
        dialog = dialog === VOID ? null : dialog;
        return this.zgo(type, id, title, state, timestamp, mostRecentMessage, mostRecentMessage.f94().g90(), readBy, actionIcon, timerState, escalationLevel, tags, dialog);
      }
      static cgp(draw, lineItem, payApp, multiple, dialog) {
        Companion_getInstance_0();
        multiple = multiple === VOID ? false : multiple;
        var tmp3_type = Type_Draw_getInstance();
        var tmp4_id = draw.q6v_1;
        var tmp5_title = 'Draw ' + payApp.k6y_1;
        var tmp6_state = new (ManualState())('Waited', AppColors_getInstance().hfz_1.xg9_1);
        var tmp0_elvis_lhs = draw.n96();
        var tmp;
        if (tmp0_elvis_lhs == null) {
          // Inline function 'com.lightningkite.now' call
          tmp = get_default(Companion_instance).d1m();
        } else {
          tmp = tmp0_elvis_lhs;
        }
        var tmp7_timestamp = tmp;
        var tmp8_mostRecentMessage = MessageData().jgp(draw, lineItem, payApp.k6y_1, multiple);
        var tmp1_safe_receiver = draw.v6v_1;
        var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.t53_1;
        var tmp_0;
        if (tmp2_elvis_lhs == null) {
          // Inline function 'kotlin.collections.setOf' call
          tmp_0 = emptySet();
        } else {
          tmp_0 = tmp2_elvis_lhs;
        }
        var tmp9_readBy = tmp_0;
        return this.bgp(tmp3_type, tmp4_id, tmp5_title, tmp6_state, tmp7_timestamp, tmp8_mostRecentMessage, tmp9_readBy, VOID, VOID, VOID, VOID, dialog);
      }
      static kgp(item, multiple, dialog) {
        Companion_getInstance_0();
        multiple = multiple === VOID ? false : multiple;
        var tmp6_type = Type_Change_getInstance();
        var tmp7_id = item.h40();
        var tmp8_title = 'Change ' + substringBefore(item.w94(), _Char___init__impl__6a9atx(46));
        var tmp9_state = new (ManualState())('Rejected', AppColors_getInstance().hfz_1.xg9_1);
        var tmp0_safe_receiver = denied(item);
        var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.b95();
        var tmp;
        if (tmp1_elvis_lhs == null) {
          var tmp2_safe_receiver = accepted(item);
          tmp = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.q54_1;
        } else {
          tmp = tmp1_elvis_lhs;
        }
        var tmp3_elvis_lhs = tmp;
        var tmp_0;
        if (tmp3_elvis_lhs == null) {
          // Inline function 'com.lightningkite.now' call
          tmp_0 = get_default(Companion_instance).d1m();
        } else {
          tmp_0 = tmp3_elvis_lhs;
        }
        var tmp10_timestamp = tmp_0;
        var tmp11_mostRecentMessage = MessageData().lgp(item, multiple);
        var tmp4_safe_receiver = denied(item);
        var tmp5_elvis_lhs = tmp4_safe_receiver == null ? null : tmp4_safe_receiver.t53_1;
        var tmp_1;
        if (tmp5_elvis_lhs == null) {
          // Inline function 'kotlin.collections.setOf' call
          tmp_1 = emptySet();
        } else {
          tmp_1 = tmp5_elvis_lhs;
        }
        var tmp12_readBy = tmp_1;
        return this.bgp(tmp6_type, tmp7_id, tmp8_title, tmp9_state, tmp10_timestamp, tmp11_mostRecentMessage, tmp12_readBy, VOID, VOID, VOID, VOID, dialog);
      }
      toString() {
        return 'ConcernCardInfo(type=' + this.igo_1.toString() + ', id=' + this.jgo_1.toString() + ', title=' + this.kgo_1 + ', state=' + toString(this.lgo_1) + ', timestamp=' + this.mgo_1.toString() + ', mostRecentMessage=' + toString(this.ngo_1) + ', messageName=' + this.ogo_1 + ', readBy=' + toString(this.pgo_1) + ', actionIcon=' + toString_0(this.qgo_1) + ', timerState=' + toString_0(this.rgo_1) + ', escalationLevel=' + toString_0(this.sgo_1) + ', tags=' + toString(this.tgo_1) + ', dialog=' + toString_0(this.ugo_1) + ')';
      }
      hashCode() {
        var result = this.igo_1.hashCode();
        result = imul(result, 31) + this.jgo_1.hashCode() | 0;
        result = imul(result, 31) + getStringHashCode(this.kgo_1) | 0;
        result = imul(result, 31) + hashCode(this.lgo_1) | 0;
        result = imul(result, 31) + this.mgo_1.hashCode() | 0;
        result = imul(result, 31) + hashCode(this.ngo_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.ogo_1) | 0;
        result = imul(result, 31) + hashCode(this.pgo_1) | 0;
        result = imul(result, 31) + (this.qgo_1 == null ? 0 : this.qgo_1.hashCode()) | 0;
        result = imul(result, 31) + (this.rgo_1 == null ? 0 : this.rgo_1.hashCode()) | 0;
        result = imul(result, 31) + (this.sgo_1 == null ? 0 : this.sgo_1.hashCode()) | 0;
        result = imul(result, 31) + hashCode(this.tgo_1) | 0;
        result = imul(result, 31) + (this.ugo_1 == null ? 0 : hashCode(this.ugo_1)) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof ConcernCardInfo()))
          return false;
        if (!this.igo_1.equals(other.igo_1))
          return false;
        if (!this.jgo_1.equals(other.jgo_1))
          return false;
        if (!(this.kgo_1 === other.kgo_1))
          return false;
        if (!equals(this.lgo_1, other.lgo_1))
          return false;
        if (!this.mgo_1.equals(other.mgo_1))
          return false;
        if (!equals(this.ngo_1, other.ngo_1))
          return false;
        if (!(this.ogo_1 === other.ogo_1))
          return false;
        if (!equals(this.pgo_1, other.pgo_1))
          return false;
        if (!equals(this.qgo_1, other.qgo_1))
          return false;
        if (!equals(this.rgo_1, other.rgo_1))
          return false;
        if (!equals(this.sgo_1, other.sgo_1))
          return false;
        if (!equals(this.tgo_1, other.tgo_1))
          return false;
        if (!equals(this.ugo_1, other.ugo_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'ConcernCardInfo', VOID, VOID, [Comparable()]);
    ConcernCardInfoClass = $;
  }
  return ConcernCardInfoClass;
}
function denied(_this__u8e3s4) {
  var tmp;
  if (_this__u8e3s4 instanceof PendingItemChange()) {
    tmp = _this__u8e3s4.l72_1;
  } else {
    if (_this__u8e3s4 instanceof PendingLineItem()) {
      tmp = _this__u8e3s4.e76_1;
    } else {
      if (_this__u8e3s4 instanceof ChangeRequestItemWrapper()) {
        tmp = denied(_this__u8e3s4.mgp_1);
      } else {
        throw IllegalArgumentException().a1('Unsupported ChangeRequestItem');
      }
    }
  }
  return tmp;
}
function accepted(_this__u8e3s4) {
  var tmp;
  if (_this__u8e3s4 instanceof PendingItemChange()) {
    tmp = _this__u8e3s4.j72_1;
  } else {
    if (_this__u8e3s4 instanceof PendingLineItem()) {
      tmp = _this__u8e3s4.d76_1;
    } else {
      if (_this__u8e3s4 instanceof ChangeRequestItemWrapper()) {
        tmp = accepted(_this__u8e3s4.mgp_1);
      } else {
        throw IllegalArgumentException().a1('Unsupported ChangeRequestItem');
      }
    }
  }
  return tmp;
}
var MessageDataClass;
function MessageData() {
  if (MessageDataClass === VOID) {
    class $ {
      static pgp(message, clientMessage, created, sender, type, readBy) {
        readBy = readBy === VOID ? emptySet() : readBy;
        var $this = createThis(this);
        $this.dgp_1 = message;
        $this.egp_1 = clientMessage;
        $this.fgp_1 = created;
        $this.ggp_1 = sender;
        $this.hgp_1 = type;
        $this.igp_1 = readBy;
        return $this;
      }
      j() {
        return this.dgp_1;
      }
      g94() {
        return this.egp_1;
      }
      i94() {
        return this.fgp_1;
      }
      h94() {
        return this.ggp_1;
      }
      f94() {
        return this.hgp_1;
      }
      t91() {
        return this.igp_1;
      }
      static jgp(draw, lineItem, number, multiple) {
        multiple = multiple === VOID ? false : multiple;
        var tmp0_safe_receiver = draw.v6v_1;
        var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.s53_1;
        var tmp = tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs;
        var tmp2_elvis_lhs = draw.n96();
        var tmp_0;
        if (tmp2_elvis_lhs == null) {
          // Inline function 'com.lightningkite.now' call
          tmp_0 = get_default(Companion_instance).d1m();
        } else {
          tmp_0 = tmp2_elvis_lhs;
        }
        var tmp_1 = tmp_0;
        var tmp3_safe_receiver = draw.v6v_1;
        var tmp4_safe_receiver = tmp3_safe_receiver == null ? null : tmp3_safe_receiver.r53_1;
        var tmp5_elvis_lhs = tmp4_safe_receiver == null ? null : tmp4_safe_receiver.m54_1;
        var tmp_2;
        if (tmp5_elvis_lhs == null) {
          var tmp6_safe_receiver = draw.u6v_1;
          tmp_2 = tmp6_safe_receiver == null ? null : tmp6_safe_receiver.m54_1;
        } else {
          tmp_2 = tmp5_elvis_lhs;
        }
        var tmp7_elvis_lhs = tmp_2;
        var tmp_3 = tmp7_elvis_lhs == null ? Companion_getInstance().m2p() : tmp7_elvis_lhs;
        var tmp_4 = new (Manual())(lineItem.k20() + ', ' + MonetaryValue__toString_impl_xslc77(draw.t6v_1) + (multiple ? ' (Multiple Waits)' : ''));
        var tmp8_safe_receiver = draw.v6v_1;
        var tmp9_elvis_lhs = tmp8_safe_receiver == null ? null : tmp8_safe_receiver.t53_1;
        var tmp_5;
        if (tmp9_elvis_lhs == null) {
          // Inline function 'kotlin.collections.setOf' call
          tmp_5 = emptySet();
        } else {
          tmp_5 = tmp9_elvis_lhs;
        }
        return this.pgp(tmp, true, tmp_1, tmp_3, tmp_4, tmp_5);
      }
      static lgp(item, multiple) {
        multiple = multiple === VOID ? false : multiple;
        var tmp0_safe_receiver = denied(item);
        var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.s53_1;
        var tmp = tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs;
        var tmp2_safe_receiver = denied(item);
        var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.b95();
        var tmp4_elvis_lhs = tmp3_elvis_lhs == null ? item.x94() : tmp3_elvis_lhs;
        var tmp_0;
        if (tmp4_elvis_lhs == null) {
          // Inline function 'com.lightningkite.now' call
          tmp_0 = get_default(Companion_instance).d1m();
        } else {
          tmp_0 = tmp4_elvis_lhs;
        }
        var tmp_1 = tmp_0;
        var tmp5_safe_receiver = denied(item);
        var tmp6_safe_receiver = tmp5_safe_receiver == null ? null : tmp5_safe_receiver.r53_1;
        var tmp7_elvis_lhs = tmp6_safe_receiver == null ? null : tmp6_safe_receiver.m54_1;
        var tmp_2;
        if (tmp7_elvis_lhs == null) {
          var tmp8_safe_receiver = accepted(item);
          tmp_2 = tmp8_safe_receiver == null ? null : tmp8_safe_receiver.m54_1;
        } else {
          tmp_2 = tmp7_elvis_lhs;
        }
        var tmp9_elvis_lhs = tmp_2;
        var tmp_3 = tmp9_elvis_lhs == null ? Companion_getInstance().m2p() : tmp9_elvis_lhs;
        var tmp_4 = new (Manual())('Change ' + item.w94() + (multiple ? ' (Multiple Rejections)' : ''));
        var tmp10_safe_receiver = denied(item);
        var tmp11_elvis_lhs = tmp10_safe_receiver == null ? null : tmp10_safe_receiver.t53_1;
        var tmp_5;
        if (tmp11_elvis_lhs == null) {
          // Inline function 'kotlin.collections.setOf' call
          tmp_5 = emptySet();
        } else {
          tmp_5 = tmp11_elvis_lhs;
        }
        return this.pgp(tmp, true, tmp_1, tmp_3, tmp_4, tmp_5);
      }
      toString() {
        return 'MessageData(message=' + this.dgp_1 + ', clientMessage=' + this.egp_1 + ', created=' + this.fgp_1.toString() + ', sender=' + this.ggp_1.toString() + ', type=' + toString(this.hgp_1) + ', readBy=' + toString(this.igp_1) + ')';
      }
      hashCode() {
        var result = getStringHashCode(this.dgp_1);
        result = imul(result, 31) + getBooleanHashCode(this.egp_1) | 0;
        result = imul(result, 31) + this.fgp_1.hashCode() | 0;
        result = imul(result, 31) + this.ggp_1.hashCode() | 0;
        result = imul(result, 31) + hashCode(this.hgp_1) | 0;
        result = imul(result, 31) + hashCode(this.igp_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof MessageData()))
          return false;
        if (!(this.dgp_1 === other.dgp_1))
          return false;
        if (!(this.egp_1 === other.egp_1))
          return false;
        if (!this.fgp_1.equals(other.fgp_1))
          return false;
        if (!this.ggp_1.equals(other.ggp_1))
          return false;
        if (!equals(this.hgp_1, other.hgp_1))
          return false;
        if (!equals(this.igp_1, other.igp_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'MessageData');
    MessageDataClass = $;
  }
  return MessageDataClass;
}
function hasConcernCard(_this__u8e3s4, history) {
  var tmp$ret$0;
  $l$block_0: {
    // Inline function 'kotlin.collections.any' call
    var tmp;
    if (isInterface(history, Collection())) {
      tmp = history.i1();
    } else {
      tmp = false;
    }
    if (tmp) {
      tmp$ret$0 = false;
      break $l$block_0;
    }
    var _iterator__ex2g4s = history.m1();
    while (_iterator__ex2g4s.n1()) {
      var element = _iterator__ex2g4s.o1();
      // Inline function 'kotlin.let' call
      var it = element.f8w();
      var tmp_0;
      if (!(it instanceof RequestComplete())) {
        tmp_0 = !(it instanceof Accept());
      } else {
        tmp_0 = false;
      }
      if (tmp_0) {
        tmp$ret$0 = true;
        break $l$block_0;
      }
    }
    tmp$ret$0 = false;
  }
  return tmp$ret$0;
}
//region block: exports
export {
  ManualState as ManualStatewy76bep9f2j,
  ConcernCardInfo as ConcernCardInfo27c6vqv7qq44u,
  MessageData as MessageDatalcsuuwceag9q,
  hasConcernCard as hasConcernCard3nodxgigqanyg,
  Type_Incident_getInstance as Type_Incident_getInstance3i10g3y530893,
  Type_LineItem_getInstance as Type_LineItem_getInstanceq184uyry7c2,
};
//endregion

//# sourceMappingURL=ConcernCardInfo.mjs.map
